import { render, staticRenderFns } from "./Gelderland.vue?vue&type=template&id=b9552dda&"
var script = {}
import style0 from "./Gelderland.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Gelderland.vue"
export default component.exports